import BarChart from "../../charts/BarChart";
import { useTabContext } from "../../../context/tabs/TabContext";
import { Grid } from "@mui/material";
import { FC, Fragment, useEffect, useState } from "react";
import { PeriodFilter } from "../../../common/enums/common.enums";
import SideInfo from "../../../pages/Platform/SideInfo";
import {
  getTotalMoneySpendForBuyingNFTs,
  getTotalMoneySpendForSellingNFTs,
} from "../../../api/clubs/club.api";
import { convertChartData } from "../../../common/helpers/chart.helper";
import { convertStatisticData } from "../../../common/helpers/statistics.helper";
import { IChart, IChartInfo } from "../../../common/interfaces/chart.interface";
import { IStatistics } from "../../../common/interfaces/statistic.interface";

const BuyAndSellsCharts: FC<{ clubAddress: string }> = ({ clubAddress }) => {
  const [sellingNFTchartTab, setSellingNFTchartTab] = useState<string>(
    PeriodFilter.DAILY
  );
  const [buyingNFTchartTab, setBuyingNFTchartTab] = useState<string>(
    PeriodFilter.DAILY
  );
  const [sellingNFTChartInfo, setSellingNFTChartInfo] = useState<IChart[]>();
  const [sellingNFTChartInfoStatistics, setSellingNFTChartInfoStatistics] =
    useState<IStatistics>();
  const [buyingNFTChartInfo, setBuyingNFTChartInfo] = useState<IChart[]>();
  const [buyingNFTChartInfoStatistics, setBuyingNFTChartInfoStatistics] =
    useState<IStatistics>();

  useEffect(() => {
    void getBuyChartInfo();
    void getSellChartInfo();
  }, []);

  const getBuyChartInfo = async () => {
    try {
      const response: IChartInfo = await getTotalMoneySpendForBuyingNFTs(
        clubAddress
      );
      const convertedChartData: IChart[] | undefined = convertChartData(
        response,
        "Total money spent for buying NFTs"
      );
      setBuyingNFTChartInfo(convertedChartData);
      const statisticData = convertStatisticData(response);
      setBuyingNFTChartInfoStatistics(statisticData);
    } catch (error) {
      console.log(error);
    }
  };
  const getSellChartInfo = async () => {
    try {
      const response: IChartInfo = await getTotalMoneySpendForSellingNFTs(
        clubAddress
      );
      const convertedChartData: IChart[] | undefined = convertChartData(
        response,
        "Total money spent for selling NFTs"
      );
      setSellingNFTChartInfo(convertedChartData);
      const statisticData = convertStatisticData(response);
      setSellingNFTChartInfoStatistics(statisticData);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Fragment>
      <Grid item xs={12} sm={12} md={6}>
        <useTabContext.Provider
          value={{
            tab: buyingNFTchartTab,
            changeTab: (tab: PeriodFilter) => setBuyingNFTchartTab(tab),
          }}
        >
          <SideInfo statisticsData={buyingNFTChartInfoStatistics} />
          <BarChart chartData={buyingNFTChartInfo} />
        </useTabContext.Provider>
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <useTabContext.Provider
          value={{
            tab: sellingNFTchartTab,
            changeTab: (tab: PeriodFilter) => setSellingNFTchartTab(tab),
          }}
        >
          <SideInfo statisticsData={sellingNFTChartInfoStatistics} />
          <BarChart chartData={sellingNFTChartInfo} />
        </useTabContext.Provider>
      </Grid>
    </Fragment>
  );
};

export default BuyAndSellsCharts;
